import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { MrpPickPackQueueGenDocContainerModel } from "../../../../../../../models/aggregates/erp/delivery/pick-pack-queue/mrp-pick-pack-queue-gen-doc-container.model";
import { ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel } from "../../../shared";

@Injectable({ providedIn: 'root' })
export class MrpPickPackQueueGenDocService extends BaseApiTemplateService<MrpPickPackQueueGenDocContainerModel> {
  endpoint_path_base = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "mrp-pick-pack-queue-to-gen-docs";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpoint_path_base + "/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = this.endpoint_path_base + "/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  public getByMultiCriteria(criteria: any, visa: ApiVisa) {
    let url = this.endpoint_path
    if(this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/query/post";
    }

    return this.httpClient.post<PagingResponseModel<MrpPickPackQueueGenDocContainerModel>>(url, criteria, this.getHttpHeader(visa));
  }
}